import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { AlertTriangle, Trash2, X } from 'lucide-react';

const ClearMonthModal = ({ isOpen, onClose, onConfirm, mes, anio, tipo, nota }) => {
  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 backdrop-blur-sm">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.95 }}
          transition={{ duration: 0.2 }}
          className="bg-white rounded-2xl shadow-xl border border-gray-100 w-full max-w-md mx-4 overflow-hidden"
        >
          {/* Header */}
          <div className="bg-red-50 border-b border-red-100 px-5 py-4 flex items-center justify-between">
            <div className="flex items-center gap-2 text-red-600">
              <AlertTriangle size={20} />
              <h3 className="font-bold m-0 text-base">Eliminar Datos del Mes</h3>
            </div>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors">
              <X size={20} />
            </button>
          </div>
          
          {/* Body */}
          <div className="p-6">
            <p className="text-gray-600 text-sm leading-relaxed m-0">
              ¿Estás seguro de que deseas eliminar TODOS los datos de <strong>{tipo}</strong> para el mes de <strong>{mes} {anio}</strong>?
            </p>
            {nota && (
              <p className="text-gray-500 text-xs leading-relaxed mt-2 m-0">{nota}</p>
            )}
            <div className="bg-orange-50 border border-orange-100 rounded-lg p-3 mt-4 flex items-start gap-3">
              <AlertTriangle size={18} className="text-orange-500 mt-0.5 flex-shrink-0" />
              <p className="text-xs text-orange-700 m-0">
                Esta acción <strong>no se puede deshacer</strong>. Asegúrate de tener un respaldo si necesitas recuperar esta información.
              </p>
            </div>
          </div>

          {/* Footer */}
          <div className="border-t border-gray-100 px-5 py-4 flex items-center justify-end gap-3 bg-gray-50/50">
            <button
              onClick={onClose}
              className="px-4 py-2 text-sm font-semibold text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition-colors"
            >
              Cancelar
            </button>
            <button
              onClick={onConfirm}
              className="px-4 py-2 text-sm font-semibold text-white bg-red-600 hover:bg-red-700 rounded-lg shadow-sm flex items-center gap-2 transition-colors"
            >
              <Trash2 size={16} />
              Sí, eliminar datos
            </button>
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
};

export default ClearMonthModal;
